/*
 * @Author: Tina Huang
 * @Date: 2024-03-11 11:03:56
 * @LastEditors: HTT httishere0728@gmail.com
 * @LastEditTime: 2025-10-23 14:56:14
 * @Description:
 */

import { Button, Result, Image, Spin, Modal, message, Alert } from 'antd'
import { useEffect, useRef, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { Picks } from '@/constants/picks'
import moment from 'moment'
import { ArrowLeftOutlined } from '@ant-design/icons'

export default function GetTemplate() {
  const { code } = useParams()
  const navigate = useNavigate()
  const [result, setResult] = useState<any>('default')
  const [targetItem, setTargetItem] = useState<any>(null)
  const [myState, setMyState] = useState<any>(null)
  const initRef = useRef({
    init: false,
  })
  const [modal, contextHolder] = Modal.useModal()

  useEffect(() => {
    // 解析参数
    if (initRef.current.init) return
    if (!code) return setResult('404')
    try {
      const state = JSON.parse(atob(decodeURIComponent(code as any)))
      const _day = moment().format('YYYYMMDD'),
        _time = `${_day}#${state.id}#time`
      setMyState(state)
      const times = Number(localStorage.getItem(_time) || 0)
      if (times >= 5) return setResult('over') // 单个模版解析次数超过3次
      if (state?.time) {
        const expired_time = new Date(state.time)
        if (new Date() > expired_time) {
          return setResult('expired')
        }
      }
      if (state?.id) {
        const item = Picks.find((current) => current.id === state.id)
        setTargetItem(item)
        // window?.splitbee?.track('View Template from admin link', { id: state.id, linkId: state.link })
        if (!initRef.current.init) {
          localStorage.setItem(_time, (times + 1).toString())
          initRef.current.init = true
        }
        return setResult('show')
      }
      throw new Error()
    } catch (err) {
      console.error(err)
      setResult('error')
    }
  }, [code])

  const handleDuplicate = () => {
    const targetLink = `https://www.notion.so/${myState?.link}?duplicate=true&pvs=36&utm_source=public_page&utm_content=duplicate_button&from=public_page&n=duplicate_public_page`
    modal.confirm({
      title: '是否已在本浏览器登录Notion账号?',
      content: (
        <>
          若未登录，请在登录后返回当前页面进行重新拷贝
          <br />
          <p className="text-rose-500">
            ❓ 若点击去拷贝无反应请点击 👉
            <a className="font-bold text-red-900" href={targetLink}>
              打开模版
            </a>
          </p>
        </>
      ),
      cancelText: '未登录，去登录',
      okText: '我已登录，去拷贝',
      centered: true,
      onOk: () => {
        if (!myState || !myState.link) return message.error('模版链接解析失败')
        // window?.splitbee.track('Duplicate template from admin link', { id: myState?.id, linkId: myState?.link })
        window.open(targetLink)
        Modal.destroyAll()
      },
      onCancel: () => {
        window.open('https://www.notion.so/login')
      },
    })
  }

  const ReturnButton = (
    <Button type="primary" shape="round" onClick={() => navigate('/')}>
      返回首页
    </Button>
  )

  const resultProps: any = {
    '404': {
      status: '404',
      title: '404',
      subTitle: '没找到该模板，请确认模板链接正确',
      extra: ReturnButton,
    },
    error: {
      status: '500',
      title: '模板解析错误',
      subTitle: '模板解析错误，请确认模板链接正确',
      extra: ReturnButton,
    },
    expired: {
      status: '500',
      title: '模板链接已过期',
      subTitle: '模板链接已过期，请联系重新获取',
      extra: ReturnButton,
    },

    over: {
      status: '500',
      title: '今日模板解析次数已达上限',
      subTitle: '已反馈到阿汪同学',
      extra: ReturnButton,
    },
  }

  return (
    <>
      {contextHolder}
      <Spin spinning={result === 'default'} fullscreen />
      {Object.keys(resultProps).includes(result) && <Result {...resultProps[result]} />}
      {result === 'show' && (
        <div style={{ maxWidth: 450, margin: '0 auto' }}>
          <Alert
            type="warning"
            description="查看更多阿汪同学模版"
            showIcon
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate('/picks')}
          />
          <div className="text-center mb-8 mt-4">
            <h1 className="text-xl font-bold">{targetItem?.title}</h1>
            <Image src={targetItem?.cover} className="my-4 rounded-md max-w-sm" />
            <Button type="primary" shape="round" block onClick={handleDuplicate}>
              拷贝到自己空间
            </Button>
          </div>
          <div className="leading-8">
            <h3 className="text-lg font-bold">模板拷贝方法：</h3>
            <p>
              第一步：在
              <a href="www.notion.so" className="font-bold text-blue-500">
                Notion官网
              </a>
              注册自己的Notion账号（若已注册请忽略）
            </p>
            <p>第二步：若未登录，请在当前浏览器登录自己的Notion账号</p>
            <p>
              第三步：点击上方的<strong>「拷贝到自己空间」</strong>按钮进行模板拷贝
            </p>
          </div>
        </div>
      )}
    </>
  )
}
